





















































import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: 'Forget',
  components: {
    Header,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/style.css" }
    ]
  },

  setup(_, context: SetupContext) {
    const state = reactive({
      email: ''
    });

    function reset() {
      alert('Trying to reset!!!');
      // TODO: Do amplify auth here.
      // TODO: 成功したらMailに戻す
      context.root.$router.push('/mailsent');
    }

    return {
      state,
      reset
    };
  }
});
